module.exports = __webpack_public_path__ + "img/bm1.jpeg";